var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.trips)?_c('div',[_c('div',{style:({height:`${_vm.height-20}px`}),attrs:{"id":"map"}}),_c('v-btn',{attrs:{"id":"placeButton2","fab":"","color":"primary"},on:{"click":_vm.togglePlaceMarkers}},[_c('v-icon',[_vm._v(_vm._s((_vm.placeShowMarkers)? 'location_on':'location_off'))])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }